import React, { useState } from "react";
import axios from "axios";
import { GoogleMapsApiKey } from "../constants/FormateDate";
import {
    GoogleMap,
    LoadScript,
    Marker,
} from "@react-google-maps/api";

const containerStyle = {
    width: "100%",
    height: "500px",
};

const CustomerAddressLocation = () => {
    const [userAddress, setUserAddress] = useState("");
    const [location, setLocation] = useState(null);

    const getCoordinates = async () => {
        if (!userAddress.trim()) {
            alert("Please enter an address");
            return;
        }

        try {
            const response = await axios.get(
                "https://maps.googleapis.com/maps/api/geocode/json",
                {
                    params: {
                        address: userAddress,
                        key: GoogleMapsApiKey,
                    },
                }
            );

            if (response.data.status === "OK") {
                const loc = response.data.results[0].geometry.location;

                setLocation(loc);
            } else {
                alert(response.data.status);
            }
        } catch (error) {
            console.error(error);
        }
    };

    return (
        <div style={{ padding: "20px" }}>
            <h3>Customer Address Location</h3>

            <input
                type="text"
                placeholder="Enter Address"
                value={userAddress}
                onChange={(e) => setUserAddress(e.target.value)}
                style={{ width: "400px", padding: "8px" }}
            />

            <button onClick={getCoordinates} style={{ marginLeft: "10px" }}>
                Get Coordinates
            </button>

            {location && (
                <div style={{ marginTop: "20px" }}>
                    <p>
                        <strong>Latitude:</strong> {location.lat}
                    </p>
                    <p>
                        <strong>Longitude:</strong> {location.lng}
                    </p>
                </div>
            )}

            <LoadScript googleMapsApiKey={GoogleMapsApiKey}>
                <GoogleMap
                    mapContainerStyle={containerStyle}
                    center={location}
                    zoom={16}
                >
                    <Marker position={location} />
                </GoogleMap>
            </LoadScript>
        </div>
    );
};

export default CustomerAddressLocation;